module.exports = "<div>\r\n    {{{Model.HtmlContent}}}\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/partials/resource-reel-item.html
// module id = 390
// module chunks = 1